import { Grid } from '@mui/material';
import React from 'react';
import { __LOCAL__ } from '../../../shared/consts';
import OpeningHours from '../OpeningHours/OpeningHours';
import OCCategories from '../OperatingCostCategories/OCCategories';
import CherryBorders from '../RentReductionCherryBorders/CherryBorders';

const Settings = () => {
	return (
		<Grid container spacing={3}>
			<Grid size={{ xs: 12 }}>
				<OpeningHours />
			</Grid>
			<Grid size={{ xs: 12 }}>
				<OCCategories />
			</Grid>
			{__LOCAL__ && (
				<Grid size={{ xs: 12 }}>
					<CherryBorders />
				</Grid>
			)}
		</Grid>
	);
};

export default Settings;
